export default function About() {
  return (
    <section id="about" className="relative py-20 md:py-32 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Photo */}
          <div className="lg:col-span-5 order-1 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-4 md:-inset-6 bg-primary-100 rounded-lg -rotate-2"></div>
              <div className="absolute -inset-2 md:-inset-3 bg-accent-100 rounded-lg rotate-1"></div>
              <div className="relative overflow-hidden rounded-lg bg-background-200 aspect-[4/5] w-full">
                <img
                  src="https://storage.readdy-site.link/project_files/47da20ca-3195-4316-9597-0e3e7f8faa54/1dc354f6-bb09-427a-9e3e-39259ccc4b1c_compressed_allen-sm.webp"
                  alt="Alon Hahamy portrait"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -right-5 md:-bottom-7 md:-right-7 bg-background-50 rounded-lg px-5 py-4 border border-background-200">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600 leading-none">30+</div>
                <div className="text-[10px] md:text-xs uppercase tracking-widest text-foreground-600 mt-1">Years experience</div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7 order-2 lg:order-2">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-600 font-semibold mb-4">
              <span className="w-8 h-px bg-primary-500"></span>
              About me
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              Three decades of engineering{" "}
              <span className="text-primary-600">what can't fail.</span>
            </h2>

            <div className="mt-6 md:mt-8 space-y-4 md:space-y-5 text-base md:text-lg leading-relaxed text-foreground-700">
              <p>
                My career started when the internet was still finding its shape. Since
                then I've spent over <strong className="text-foreground-950">30 years</strong>{" "}
                architecting Computer Networks and Data Center Infrastructure, and more
                than <strong className="text-foreground-950">25 years</strong> in High‑Tech
                Security and IoT — from the wire in the wall to the analytics dashboard
                a CIO checks at 3 a.m.
              </p>
              <p>
                I've been trusted by{" "}
                <span className="text-foreground-950 font-medium">
                  Federal, State and Local Governments, Airports, Military and Law
                  Enforcement
                </span>
                , along with enterprises like Meta, Arvato‑Bertelsmann, DHL, Hertz and
                Amtrak, to deliver systems that stay online, stay secure, and scale.
              </p>
              <p>
                Today I run a portfolio of companies focused on hosting, AI, security,
                training and connected infrastructure — helping teams move fast without
                breaking what actually matters.
              </p>
            </div>

            <div className="mt-8 md:mt-10 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {[
                { i: "ri-shield-check-line", t: "Mission-critical" },
                { i: "ri-government-line", t: "Gov-grade" },
                { i: "ri-cpu-line", t: "IoT & Edge" },
                { i: "ri-server-line", t: "Data centers" },
                { i: "ri-global-line", t: "Enterprise scale" },
                { i: "ri-lock-2-line", t: "Zero-trust" },
              ].map((tag) => (
                <div
                  key={tag.t}
                  className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100/70 px-3 py-2.5"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-primary-600">
                    <i className={`${tag.i} text-lg`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {tag.t}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}